import { withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core/";

export const MpaStandardButton = withStyles({
  root: props => ({
    color: "rgb(255,255,255,1.0)",
    backgroundColor: props.assignedcolor,
    "&:hover": {
      backgroundColor: props.assignedcolor
    }
  })
})(Button);
